import { FC } from 'react';
import { Button } from 'atoms/Button';
import { useTranslations } from 'modules/i18n/useTranslations';
import { AppRoutes } from 'modules/shop/routes';
import { useLogout, useUser } from 'modules/shop/user/hooks';
import styles from '../styles.module.css';

export const SidebarButtons: FC = () => {
  const t = useTranslations();
  const { user } = useUser();
  const { handleLogout } = useLogout();

  return (
    <div className={styles.container}>
      {user ? (
        <>
          <Button
            color="deep-purple"
            href={AppRoutes.ACCOUNT}
            className={styles.button}
          >
            {t('common.buttons.customer-account')}
          </Button>
          <Button
            color="deep-purple"
            onClick={handleLogout}
            className={styles.button}
          >
            {t('common.buttons.logout')}
          </Button>
        </>
      ) : (
        <Button
          color="deep-purple"
          href={AppRoutes.LOGIN as string}
          className={styles.button}
        >
          {t('common.buttons.login')}
        </Button>
      )}
    </div>
  );
};
